(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tpa-scrolling-text"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
    const section = document.currentScript.closest('.scrolling-icons-section');
    const track = section.querySelector('.scrolling-icons-track');
    const speed = "{{ section.settings.scroll_speed | default: '20s' }}";
    track.style.setProperty('--scroll-speed', speed);
  });

  } catch(e) { console.error(e); }
})();
})();
